<template>
	<LayoutTableCommonRow>
		<LayoutTableCommonPartImage :src="user.avatar_url" size="md" />
		<LayoutTableCommonPartText :text="user.name" :subtext="user.email" :header="`Desde ${dateFormatted}`" />
		<LayoutTableCommonPartInfo :info="roles" />
		<LayoutTableCommonPartMenu>
			<template #options>
				<router-link :to="{ name: 'company.admin.user.form', params: { id: user.id }}" class="dropdown-item rounded-0">Editar</router-link>
				<a href="javascript:void(0)" class="dropdown-item rounded-0" @click="remove">Eliminar</a>
			</template>
		</LayoutTableCommonPartMenu>
	</LayoutTableCommonRow>
</template>

<script>
	import { computed, inject } from 'vue';
	import _ from 'lodash';
	import moment from 'moment';

	export default {
		emits: ['remove'],
		props: {
			user: Object
		},
		setup(props, { emit }) {
			const $env = inject('$env');
			const dateFormatted = computed(() => moment(props.user.created_at).format('DD/MM/YYYY'));
			const remove = () => emit('remove', props.user);

			const roles = computed(() => {
				let data = [];
				_.forEach(props.user.pivot.roles, (role) => {
					data.push($env.MODEL.User.roles[role].title);
				});

				return data.join('<br />');
			});

			return { dateFormatted, remove, roles };
		}
	}
</script>